var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("ProjectPlanEditor", {
        attrs: { viewModel: _vm.projectPlanEditor },
        on: { "form-submit": _vm.handleProjectPlanEditorFormSubmit },
      }),
      _vm._v(" "),
      _vm.isWorkspaceMember
        ? _c("PortfolioNavigation", {
            attrs: {
              workspaceId: _vm.workspaceId,
              projectId: _vm.tchProjectId,
            },
          })
        : _vm.isProjectOwner
        ? _c("Navigation")
        : _vm._e(),
      _vm._v(" "),
      _vm.rm
        ? _c(
            "div",
            {
              staticClass: "container-fluid",
              staticStyle: { "margin-top": "80px", "padding-top": "40px" },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-6" }, [
                  _c(
                    "h1",
                    {
                      staticStyle: {
                        "font-size": "2em",
                        "font-weight": "300",
                        color: "#33475b",
                        margin: "0",
                      },
                    },
                    [_vm._v(_vm._s(_vm.rm.ProjectName))]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6 text-right align-self-end" },
                  [
                    _c("div", { staticClass: "dropdown d-inline" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-secondary",
                          staticStyle: { padding: "0.7em 2em" },
                          attrs: { type: "button", "data-toggle": "dropdown" },
                        },
                        [
                          _vm._v(
                            "\n                        Create a business case\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "dropdown-menu dropdown-menu-right",
                          staticStyle: {
                            "max-height": "300px",
                            "overflow-y": "auto",
                          },
                        },
                        [
                          _c("h6", { staticClass: "dropdown-header" }, [
                            _vm._v("Business case templates"),
                          ]),
                          _vm._v(" "),
                          !_vm.planTemplates.length
                            ? _c(
                                "small",
                                {
                                  staticClass:
                                    "text-muted px-4 mb-1 font-italic d-block",
                                },
                                [
                                  _vm._v(
                                    "\n                            You don't have any templates yet.\n                        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.planTemplates, function (t) {
                            return _c(
                              "a",
                              {
                                key: t.Id,
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.showPlanCreator(t)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(t.Name) +
                                    "\n                        "
                                ),
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "dropdown-divider" }),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function ($event) {
                                  return _vm.showPlanCreator()
                                },
                              },
                            },
                            [_vm._v("Custom business case")]
                          ),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "sanitizedHref",
                            rawName: "v-sanitizedHref",
                            value: `/#/alternative/dashboard/${_vm.workspaceId}/${_vm.tchProjectId}/${_vm.projectId}`,
                            expression:
                              "`/#/alternative/dashboard/${workspaceId}/${tchProjectId}/${projectId}`",
                          },
                        ],
                        staticClass: "btn btn-outline-secondary",
                        staticStyle: { padding: "0.7em 2em" },
                      },
                      [_vm._v("Meta data")]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _vm.rm
                ? _c("div", [
                    _vm.rm.Plans.length === 0
                      ? _c("div", [
                          _c("div", { staticClass: "dropdown d-inline" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-success",
                                staticStyle: { padding: "0.7em 2em" },
                                attrs: {
                                  type: "button",
                                  "data-toggle": "dropdown",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        Create a business case\n                    "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "dropdown-menu dropdown-menu-right",
                                staticStyle: {
                                  "max-height": "300px",
                                  "overflow-y": "auto",
                                },
                              },
                              [
                                _c("h6", { staticClass: "dropdown-header" }, [
                                  _vm._v("Business case templates"),
                                ]),
                                _vm._v(" "),
                                !_vm.planTemplates.length
                                  ? _c(
                                      "small",
                                      {
                                        staticClass:
                                          "text-muted px-4 mb-1 font-italic d-block",
                                      },
                                      [
                                        _vm._v(
                                          "\n                            You don't have any templates yet.\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(_vm.planTemplates, function (t) {
                                  return _c(
                                    "a",
                                    {
                                      key: t.Id,
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.showPlanCreator(t)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(t.Name) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "dropdown-divider" }),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.showPlanCreator()
                                      },
                                    },
                                  },
                                  [_vm._v("Custom business case")]
                                ),
                              ],
                              2
                            ),
                          ]),
                        ])
                      : _c(
                          "div",
                          [
                            _c("ProjectNavigation", {
                              staticClass: "mt-4 mb-4",
                              attrs: {
                                ActivePage: "summary",
                                workspaceId: _vm.workspaceId,
                                tchProjectId: _vm.tchProjectId,
                                projectId: _vm.projectId,
                                planId: "",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "table",
                              {
                                staticClass: "table table-bordered table-hover",
                              },
                              [
                                _vm._m(0),
                                _vm._v(" "),
                                _c(
                                  "tbody",
                                  [
                                    _vm.activePlan
                                      ? _c("tr", [
                                          _c("td", [
                                            _c(
                                              "a",
                                              {
                                                directives: [
                                                  {
                                                    name: "sanitizedHref",
                                                    rawName: "v-sanitizedHref",
                                                    value: `/#/q/project/revenues/${_vm.workspaceId}/${_vm.tchProjectId}/${_vm.projectId}/${_vm.activePlan.Id}`,
                                                    expression:
                                                      "`/#/q/project/revenues/${workspaceId}/${tchProjectId}/${projectId}/${activePlan.Id}`",
                                                  },
                                                ],
                                                staticClass: "text-primary",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.activePlan.Name)
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-center" },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getFormattedDateStr(
                                                      _vm.activePlan.CreatedDate
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c("small", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getFormattedTimeStr(
                                                      _vm.activePlan.CreatedDate
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-center" },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getFormattedDateStr(
                                                      _vm.activePlan
                                                        .ModifiedDate
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c("small", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getFormattedTimeStr(
                                                      _vm.activePlan
                                                        .ModifiedDate
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-center" },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getFormattedDateStr(
                                                      _vm.activePlan
                                                        .ActivationDate
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c("small", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getFormattedTimeStr(
                                                      _vm.activePlan
                                                        .ActivationDate
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-center" },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getFormattedDateStr(
                                                      _vm.activePlan
                                                        .SubmissionDate
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c("small", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getFormattedTimeStr(
                                                      _vm.activePlan
                                                        .SubmissionDate
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-center" },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getFormattedDateStr(
                                                      _vm.activePlan
                                                        .SubmissionDueDate
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c("small", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getFormattedTimeStr(
                                                      _vm.activePlan
                                                        .SubmissionDueDate
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-center" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.activePlan.Duration)
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-center" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.activePlan.Granularity
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-center" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.activePlan.Denomination
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c(
                                              "div",
                                              { staticClass: "btn-group" },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-outline-secondary dropdown-toggle",
                                                    attrs: {
                                                      type: "button",
                                                      "data-toggle": "dropdown",
                                                    },
                                                  },
                                                  [_vm._v("Actions")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "dropdown-menu dropdown-menu-right",
                                                  },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "dropdown-item",
                                                        attrs: {
                                                          disabled:
                                                            _vm.activePlan
                                                              .IsSubmitted,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.showPlanEditor(
                                                              _vm.activePlan
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                            Settings\n                                        "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("div", {
                                                      staticClass:
                                                        "dropdown-divider",
                                                    }),
                                                    _vm._v(" "),
                                                    !_vm.activePlan.IsSubmitted
                                                      ? _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "dropdown-item",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.handleSubmitProjectPlanCommand(
                                                                  _vm.activePlan
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                            Submit\n                                        "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.activePlan
                                                      .IsSubmitted &&
                                                    _vm.isWorkspaceMember
                                                      ? _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "dropdown-item",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.handleUnsubmitProjectPlanCommand(
                                                                  _vm.activePlan
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                            Unsubmit\n                                        "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "dropdown-item",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleCloneProjectPlanCommand(
                                                              _vm.activePlan
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                            Clone\n                                        "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "dropdown-item",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleExportProjectPlanCommand(
                                                              _vm.activePlan
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                            Download as xls\n                                        "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("div", {
                                                      staticClass:
                                                        "dropdown-divider",
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "dropdown-item",
                                                        attrs: { disabled: "" },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                            Delete\n                                        "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.backupPlans.length > 0
                                      ? _c(
                                          "tr",
                                          { staticClass: "table-secondary" },
                                          [
                                            _c(
                                              "td",
                                              { attrs: { colspan: "10" } },
                                              [_vm._v("Backup business cases")]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm._l(_vm.backupPlans, function (plan) {
                                      return _c("tr", { key: plan.Id }, [
                                        _c("td", [
                                          _c(
                                            "a",
                                            {
                                              directives: [
                                                {
                                                  name: "sanitizedHref",
                                                  rawName: "v-sanitizedHref",
                                                  value: `/#/q/project/revenues/${_vm.workspaceId}/${_vm.tchProjectId}/${_vm.projectId}/${plan.Id}`,
                                                  expression:
                                                    "`/#/q/project/revenues/${workspaceId}/${tchProjectId}/${projectId}/${plan.Id}`",
                                                },
                                              ],
                                              staticClass: "text-primary",
                                            },
                                            [_vm._v(_vm._s(plan.Name))]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-center" },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getFormattedDateStr(
                                                    plan.CreatedDate
                                                  )
                                                )
                                              ),
                                            ]),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c("small", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getFormattedTimeStr(
                                                    plan.CreatedDate
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-center" },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getFormattedDateStr(
                                                    plan.ModifiedDate
                                                  )
                                                )
                                              ),
                                            ]),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c("small", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getFormattedTimeStr(
                                                    plan.ModifiedDate
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-center" },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getFormattedDateStr(
                                                    plan.ActivationDate
                                                  )
                                                )
                                              ),
                                            ]),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c("small", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getFormattedTimeStr(
                                                    plan.ActivationDate
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-center" },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getFormattedDateStr(
                                                    plan.SubmissionDate
                                                  )
                                                )
                                              ),
                                            ]),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c("small", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getFormattedTimeStr(
                                                    plan.SubmissionDate
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-center" },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getFormattedDateStr(
                                                    plan.SubmissionDueDate
                                                  )
                                                )
                                              ),
                                            ]),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c("small", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getFormattedTimeStr(
                                                    plan.SubmissionDueDate
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-center" },
                                          [_vm._v(_vm._s(plan.Duration))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-center" },
                                          [_vm._v(_vm._s(plan.Granularity))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-center" },
                                          [_vm._v(_vm._s(plan.Denomination))]
                                        ),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c(
                                            "div",
                                            { staticClass: "btn-group" },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-outline-secondary dropdown-toggle",
                                                  attrs: {
                                                    type: "button",
                                                    "data-toggle": "dropdown",
                                                  },
                                                },
                                                [_vm._v("Actions")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "dropdown-menu dropdown-menu-right",
                                                },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "dropdown-item",
                                                      attrs: {
                                                        disabled:
                                                          plan.IsSubmitted,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.showPlanEditor(
                                                            plan
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                            Settings\n                                        "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("div", {
                                                    staticClass:
                                                      "dropdown-divider",
                                                  }),
                                                  _vm._v(" "),
                                                  !plan.IsSubmitted
                                                    ? _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "dropdown-item",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleSubmitProjectPlanCommand(
                                                                plan
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                            Submit\n                                        "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  plan.IsSubmitted &&
                                                  _vm.isWorkspaceMember
                                                    ? _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "dropdown-item",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleUnsubmitProjectPlanCommand(
                                                                plan
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                            Unsubmit\n                                        "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "dropdown-item",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleCloneProjectPlanCommand(
                                                            plan
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                            Clone\n                                        "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "dropdown-item",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleUpdateProjectActivePlanCommand(
                                                            plan
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                            Set as Active\n                                        "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "dropdown-item",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleExportProjectPlanCommand(
                                                            plan
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                            Download as xls\n                                        "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("div", {
                                                    staticClass:
                                                      "dropdown-divider",
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "dropdown-item",
                                                      attrs: {
                                                        disabled:
                                                          plan.IsSubmitted,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleDeleteProjectPlanCommand(
                                                            plan
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                            Delete\n                                        "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ])
                                    }),
                                  ],
                                  2
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", { staticClass: "table-secondary" }, [
        _c("th", [_vm._v("Active business case")]),
        _vm._v(" "),
        _c(
          "th",
          { staticClass: "text-center", staticStyle: { width: "150px" } },
          [_vm._v("Created")]
        ),
        _vm._v(" "),
        _c(
          "th",
          { staticClass: "text-center", staticStyle: { width: "150px" } },
          [_vm._v("Modified")]
        ),
        _vm._v(" "),
        _c(
          "th",
          { staticClass: "text-center", staticStyle: { width: "150px" } },
          [_vm._v("Activated")]
        ),
        _vm._v(" "),
        _c(
          "th",
          { staticClass: "text-center", staticStyle: { width: "150px" } },
          [_vm._v("Submitted")]
        ),
        _vm._v(" "),
        _c(
          "th",
          { staticClass: "text-center", staticStyle: { width: "150px" } },
          [_vm._v("Submission due")]
        ),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Duration (months)")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Granularity")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Denomination")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "120px" } }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }